/**
 * @fileoverview The class strings the Plant Doctor's window and answer blocks share.
 *
 * Moved word for word out of PlantDoctor (audit batch 18, A107). Colours are
 * theme colours only.
 *
 * Where: PlantDoctor, DoctorAnswerView, AnswerBlocks, FollowUp.
 *
 * @module doctorStyles
 */

import { cn } from '@/lib/utils';

/** Small grey text that still passes AA on the cream grounds (the theme's muted grey does not on Field notes). */
export const QUIET = 'text-foreground/80';

/** A small uppercase heading inside a box. */
export const SMALL_HEADING = cn('text-xs font-semibold uppercase tracking-wide', QUIET);

/** A folded section's tappable row: full width, 44px tall, with a chevron that turns when open. */
export const FOLD_ROW = 'flex min-h-11 cursor-pointer list-none items-center justify-between gap-2 px-3 text-sm font-semibold hover:bg-muted [&::-webkit-details-marker]:hidden';
